/**
 * SearchSubscriptionsUseCase
 * Use case for searching subscriptions by first or last name
 */

import type { PageCursor } from '@/data/types/json';
import { SubscriptionService } from '@/domain/services/subscription/subscriptionService';
import { ExclusiveContentSubscriptionRemapper } from '@/domain/remappers/exclusiveContentSubscription/exclusiveContentSubscriptionRemapper';
import type { ExclusiveContentSubscriptionEntity } from '@/domain/entities/exclusiveContentSubscription/exclusiveContentSubscriptionEntity';

export interface SearchSubscriptionsResult {
  subscriptions: ExclusiveContentSubscriptionEntity[];
  hasMore: boolean;
  cursor?: PageCursor;
}

export class SearchSubscriptionsUseCase {
  private subscriptionService: SubscriptionService;

  constructor() {
    this.subscriptionService = SubscriptionService.getInstance();
  }

  async execute(
    currentUserId: string,
    keyword: string,
    cursor?: PageCursor,
    limit?: number,
    searchLastName: boolean = false
  ): Promise<SearchSubscriptionsResult> {
    const result = await this.subscriptionService.searchSubscriptions(
      currentUserId,
      keyword,
      cursor,
      limit,
      searchLastName
    );

    const subscriptions = ExclusiveContentSubscriptionRemapper.fromDtoList(
      ExclusiveContentSubscriptionRemapper.fromJsonList(result.items)
    );

    return {
      subscriptions,
      hasMore: result.hasMore,
      cursor: result.cursor,
    };
  }
}

export const createSearchSubscriptionsUseCase = () => new SearchSubscriptionsUseCase();
